export default "__VITE_ASSET__BI_jZ90k__"